import React, { useEffect, useState } from "react";

import { useInView } from "react-intersection-observer";
import "../style/contact.css";
import Typical from 'react-typical'





export default function Contact (props)
{

    const { ref, inView, entry } = useInView({
        /* Optional options */
        threshold:0.9,
        triggerOnce: true,
      });
    

    return(
        <div className="contact_container" ref={ref} inView={inView}>
            {inView && <section className="contact_section">
                <div className="contact_box">
                    <h2 className="contact_headlin"><Typical steps={['I hope you liked my site', 1500, 'Lets have some coffy :)', 1500,'tea ;)',1000,' My contact is coming up',1500,'Have a nice day',1500]} loop={1} /></h2>
                    <h3 className="contact_budy"></h3>
                   
                </div>
                 <div className="contact_info">
                        <div className="phone info">
                            <h2 className="info_h2">Phone Number: <span>0542126125</span></h2>
                        </div>
                        <div className="mail info">
                            <h2 className="info_h2 ">E-Mail: <span>hezirahmani@gmail.com</span></h2>
                        </div>
                        <div className="linkdin">
                            <h2 className="info_h2"><a className="linkdin_link" href="https://www.linkedin.com/in/hezi-rahmani-7a5a471b4" target="blank">linkdin</a></h2>
                        </div>
                    </div>
            </section>}
        </div>
    )
} 
{/* <Typical steps={['i hope you enjoyd my site', 1000, 'lets have some coffy', 1000,'beer ;)',500]} loop={Infinity} wrapper="h2"/> */}